import { render, staticRenderFns } from "./SinaleiraLucratividade.vue?vue&type=template&id=20825c1c&scoped=true"
import script from "./SinaleiraLucratividade.vue?vue&type=script&lang=js"
export * from "./SinaleiraLucratividade.vue?vue&type=script&lang=js"
import style0 from "./SinaleiraLucratividade.vue?vue&type=style&index=0&id=20825c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20825c1c",
  null
  
)

export default component.exports